"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IntroductionGalerie() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return;
}